// extracted by mini-css-extract-plugin
module.exports = {"sideContainer":"VehiclePartsList_sideContainer__nDxR_","spin":"VehiclePartsList_spin__2-eUw"};